export const ConditionMapping = Object.freeze({
  code: "邀请码",
  name: "姓名",
  mobile: "注册手机号",
  idcard: "证件号码",
  email: "邮箱",
  company: "公司名称",
  mobileOrEmail: "注册手机号或邮箱",
});

// 使用箭头函数和解构赋值来简化转换函数
export const translateConditionToZhCN = (condition) =>
  ConditionMapping[condition];
